import { render, staticRenderFns } from "./Entrepreneur.vue?vue&type=template&id=410998ba"
import script from "./Entrepreneur.vue?vue&type=script&lang=js"
export * from "./Entrepreneur.vue?vue&type=script&lang=js"
import style0 from "./Entrepreneur.vue?vue&type=style&index=0&id=410998ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports